// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';

// if advisor turn off the dashboard access, user can only see the profile page
// eslint-disable-next-line require-await
const dashboardAccess = async (to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
  if (to.meta.isLoginRoute || to.meta.cdo || to.meta.publicRoute) {
    next();

    return;
  }

  if (!store.getters.hasDashboardAccess && !to.meta.withoutDashboardAccess) {
    next({name: 'UserProfile'});

    return;
  }

  next();
};

export default dashboardAccess;
